/*
 *
 * Copyright 2019, White River Computing LLC. All rights reserved.
 * For licensing information, please contact Charlie Flock (cflock@whiterivercomputing.com or 888-802-6340)
 */

import React from 'react';
import ReactDOM from "react-dom";
import {Button, Dialog, Classes, HTMLSelect, TextArea} from "@blueprintjs/core";
import {NonIdealState, Alert} from "@blueprintjs/core";
import {Intent} from "@blueprintjs/core/lib/esm/index";
import {IconNames} from "@blueprintjs/icons";
import {WrcCardHeader} from "./WrcCardHeader";
import {WrcServer} from "./WrcServer.js";
import {WrcGlobal} from "./WrcGlobal.js";

export class WrcEmail extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            is_loaded: false,
            email_created: false,
            email_body_initialized: false,
            raw_email_content:[],
            user:{}
        };
    }

    componentDidMount() {
        let recipient_name_query_args= this.props.recipients.recipient_name_query_args.map((arg) => {
            return this.props.record[arg];
        }, this);

        let recipient_email_query_args= this.props.recipients.recipient_email_query_args.map((arg) => {
            return this.props.record[arg];
        }, this);

        let post = {
            table_schema: this.props.table_schema,
            recipient_name_query: this.props.recipients.recipient_name_query,
            recipient_name_query_args: recipient_name_query_args,
            recipient_email_query: this.props.recipients.recipient_email_query,
            recipient_email_query_args: recipient_email_query_args,
            status: 'create'
        };

        WrcServer.post('email-handler',
            post,
            (content) => this.setUpForm(content)
        );
    }

    render() {
        if (this.state.is_loaded){
            return (
                <Dialog
                        isOpen={true}
                        onClose={this.closeEmail}
                        canOutsideClickClose={false}
                        title={this.props.title}
                        id="web_form"
                        style={{minWidth: 1100, minHeight: 600, maxWidth: 1400, maxHeight: 800, overflow: 'scroll'}} >
                    <div className={Classes.DIALOG_BODY}>
                        <div>
                            <span style={{'marginRight': '4px'}}>{this.props.date_component.label}</span>
                            <div class="bp3-input-group">
                              <input
                                    className={'bp3-input'}
                                    style={{'marginBottom': '4px', 'width': '20%'}}
                                    name={this.props.date_component.label}
                                    type='date'
                                    onChange={(e) => (this.setState({selected_date: e.target.value}))}
                              />
                            </div>
                            <div>
                                <span style={{'marginRight': '4px'}}>{this.props.recipients.recipient_name_label}</span>
                                <HTMLSelect
                                    value={this.state.recipient_name.name}
                                    style={{'marginBottom': '4px'}}
                                    onChange={this.handleRecipientNameChange}
                                    disabled={this.props.specified_recipient_name}
                                    options={this.state.recipient_name_options.map((elem) => (elem.name))} />
                            </div>
                            <div>
                                <Button
                                    disabled={!(this.state.selected_date !== undefined && this.state.recipient_name !== undefined && this.state.recipient_name.name !=="Select...")}
                                    icon='edit'
                                    text='Compose Email'
                                    type='submit'
                                    style={{'marginBottom': '4px'}}
                                    intent={Intent.SUCCESS}
                                    onClick={this.composeEmail}
                                />
                            </div>
                        </div>
                        <div style={{'marginBottom': '4px'}}>
                            {this.state.email_created &&
                                <div>
                                    <div class="bp3-input-group">
                                        <span style={{'marginRight': '4px'}}>To: </span>
                                        <input
                                            className={'bp3-input'}
                                            style={{'marginBottom': '4px', 'width': '50%'}}
                                            name='recipient_email'
                                            type='email'
                                            value={this.state.recipient_email.email}
                                            disabled={this.props.specified_recipient_email}
                                            onChange={this.handleRecipientEmailChange}
                                        />
                                    </div>
                                    <div class="bp3-input-group">
                                        <span style={{'marginRight': '4px'}}>Subject: </span>
                                        <input
                                            disabled={true}
                                            className={'bp3-input'}
                                            style={{'marginBottom': '4px', 'width': '50%'}}
                                            name='subject'
                                            type='text'
                                            value={this.state.subject}
                                        />
                                    </div>
                                    <div>
                                        <TextArea
                                            growVertically={true}
                                            large={true}
                                            intent={Intent.PRIMARY}
                                            onChange={(e) => (this.setState({email_body: e.target.value}))}
                                            style={{'marginBottom': '4px', 'width': '80%', 'height': '450px'}}
                                            value={this.state.email_body} />
                                    </div>
                                    <div>
                                        <span>You will be able to review your email with your default email client to make any additional changes</span>
                                        {(this.state.email_body_initialized && this.state.recipient_email !== undefined && this.state.email_body !== undefined) &&
                                        <div>
                                            <a
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                href={`mailto:${this.state.recipient_email.email}?subject=${this.state.subject}&body=${encodeURIComponent(this.state.email_body)}`}>
                                                <div>
                                                    <Button
                                                        icon='envelope'
                                                        text='Send Email'
                                                        type='submit'
                                                        style={{'marginBottom': '4px'}}
                                                        intent={Intent.SUCCESS}
                                                        onClick={this.sendEmail} />
                                                </div>
                                            </a>
                                        </div>}
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                    <div className={Classes.DIALOG_FOOTER}>
                        <div className={'bp3-dialog-footer-actions'} style={{float: 'right', padding: 10}}>
                            <Button onClick={this.closeEmail} text="Cancel" type={'button'}/>
                        </div>
                    </div>
                </Dialog>
            );
        } else {
            return (
                <Dialog
                        isOpen={true}
                        canOutsideClickClose={false}
                        title={this.props.title}
                        id="web_form"
                        style={{minWidth: 1100, minHeight: 600, maxWidth: 1400, maxHeight: 800, overflow: 'scroll'}} >
                    <div className={Classes.DIALOG_BODY}>
                        <NonIdealState icon='envelope' title='No Email Template Created' description={this.props.non_ideal_state_message}/>
                    </div>
                    <div className={Classes.DIALOG_FOOTER}>
                        <div className={'bp3-dialog-footer-actions'} style={{float: 'right', padding: 10}}>
                            <Button onClick={this.closeEmail} text="Close" type={'button'}/>
                        </div>
                    </div>
                </Dialog>
            );
        }
    }

    handleRecipientEmailChange = (e) => {
        let recipient_email={"email": e.target.value, "kap_id": undefined};
        this.setState({recipient_email: recipient_email});
    }

    handleRecipientNameChange = (e) => {
        let recipient_name=this.state.recipient_name_options.find((obj) => {
            return obj.name===e.target.value;
        }, this);
        let recipient_email=this.state.recipient_email_options.find((obj) => {
            return obj.kap_id===recipient_name.kap_id;
        }, this);
        this.setState({recipient_name: recipient_name, recipient_email: recipient_email});
    }

    fillEmail = () => {
        let today = WrcGlobal.get_db_today();
        let content = this.state.template.content;
        let subject= this.state.subject;
        content = content.replace(new RegExp("~recipient_name~", "g"), this.state.recipient_name.name);
        content = content.replace(new RegExp("~recipient_email~", "g"), this.state.recipient_email.email);
        subject = subject.replace(new RegExp("~recipient_name~", "g"), this.state.recipient_name.name);
        subject = subject.replace(new RegExp("~recipient_email~", "g"), this.state.recipient_email.email);
        for (let user_field in this.state.user) {
            if(this.state.user[user_field] !== undefined && this.state.user[user_field] !== null){
                content = content.replace(new RegExp("~user." + user_field + "~", "g"), this.state.user[user_field]);
            } else if (user_field === 'phone_number'){
                content = content.replace(new RegExp("~user.phone_number~", "g"), "___-___-____");
            }
        }
        let date_parts=this.state.selected_date.split("-").map((elem) => (parseInt(elem)));
        let formatted_date= date_parts[1].toString()+"/"+date_parts[2].toString()+"/"+date_parts[0].toString();
        subject = subject.replace(new RegExp("~selected_date~", "g"), formatted_date);
        this.state.template.content_parameters.main.forEach((field) => {
            if(Object.keys(this.state).includes(field)){
                if (field==='selected_date'){
                    content = content.replace(new RegExp("~" + field + "~", "g"), formatted_date);
                } else {
                    content = content.replace(new RegExp("~" + field + "~", "g"), this.state[field]);
                }
            }
        }, this);

        Object.keys(this.state.template.content_parameters).forEach((param_list) => {
            if(param_list !== "main"){
                let content_list=[];
                this.state.raw_email_content.forEach((result) => {
                    let filler_template=this.state.template.content_formatting[param_list];
                    this.state.template.content_parameters[param_list].forEach((field) => {
                        if(Object.keys(result).includes(field)){
                            filler_template = filler_template.replace(new RegExp("~" + field + "~", "g"), result[field]);
                        }
                    }, this);
                    content_list.push(filler_template);
                }, this);
                content = content.replace(new RegExp("~" + param_list + "~", "g"), content_list.join('\n'));
            }
        }, this);

        this.setState({
            email_body: content,
            subject: subject,
            email_body_initialized: true
        });
    }

    emailSent = (content) => {
        this.setState({email_sent:true});
    }
    sendEmail = (e) => {
        let alertBox = (
            <Alert
                cancelButtonText="No"
                confirmButtonText="Yes"
                isOpen={true}
                intent={Intent.SUCCESS}
                icon={IconNames.TICK}
                onCancel={this.cancelAlert}
                onConfirm={this.saveEmail}>
                <p>Do you want to record that you sent this email?</p>
            </Alert>
        );
        ReactDOM.render(alertBox, document.querySelector('#alertdiv'));
    }

    saveEmail = (e) => {
        WrcServer.post('save-form',
            {table_schema: this.state.table_schema, table_name: this.state.table_name, data: {[this.props.recipient_type]: this.state.recipient_name.name, "kap_id":this.state.recipient_name.kap_id, "entry_date": WrcGlobal.get_db_today()}},
            (content) => this.afterSave(content)
        );
    }

    afterSave = (content) => {
        ReactDOM.unmountComponentAtNode(document.querySelector('#alertdiv'));
        this.props.refresh();
        this.closeEmail();
    }

    setUpForm= (content) => {
        let names_loaded= false;
        let emails_loaded= false;
        let recipient_name=undefined;
        let recipient_email=undefined;
        let recipient_name_options=[];
        let recipient_email_options=[];
        if(Array.isArray(content.recipient_name_options) && content.recipient_name_options.length >0){
            if(content.recipient_name_options.length > 1){
                recipient_name_options=[...content.recipient_name_options];
                recipient_name_options.unshift({"name":"Select..."});
            } else {
                recipient_name_options=[...content.recipient_name_options];
                recipient_name=content.recipient_name_options[0];
            }
            names_loaded=true;
        }

        if(Array.isArray(content.recipient_email_options) && content.recipient_email_options.length >0){
            recipient_email_options=[...content.recipient_email_options];
            if(content.recipient_email_options.length ===1){
                recipient_email=content.recipient_email_options[0];
            }
            emails_loaded=true;
        }

        let is_loaded=(names_loaded && emails_loaded);
        this.setState({
            recipient_name_options: recipient_name_options,
            recipient_email_options: recipient_email_options,
            is_loaded: is_loaded,
            template: this.props.template,
            subject: this.props.default_subject,
            table_schema: this.props.table_schema,
            table_name: this.props.table_name,
            user: this.props.user,
            recipient_name: recipient_name,
            recipient_email: recipient_email
        });
    }

    processEmailContent= (content) => {
        this.setState({
            email_created: true,
            raw_email_content: content
        });
        this.fillEmail();
    }

    composeEmail = (e) => {
        let date_parts=this.state.selected_date.split("-").map((elem) => (parseInt(elem)));
        let post = {
            arg_int_year: date_parts[0],
            arg_int_month: date_parts[1],
            arg_int_day: date_parts[2],
            arg_selected_recipient_name: this.state.recipient_name.name,
            content_query: this.props.content_query.query,
            argument_order: this.props.content_query.argument_order,
            status: 'generate'
        };

        WrcServer.post('email-handler',
            post,
            (content) => this.processEmailContent(content)
        );
    }

    closeEmail = () => {
        ReactDOM.unmountComponentAtNode(document.querySelector('#email'));
    };

    cancelAlert() {
      ReactDOM.unmountComponentAtNode(document.querySelector('#alertdiv'));
    }
}
